export const GAME_CONSTANTS = {
  // Attempt limits
  MAX_ATTEMPTS: 3,

  // Countdown timing (in milliseconds)
  COUNTDOWN_STEP_DURATION: 650, // Time between each countdown step
  COUNTDOWN_INITIAL_DELAY: 550, // Time before the countdown starts
  COUNTDOWN_GO_DISPLAY_DURATION: 400, // Time the "GO!" text is displayed

  // Timing (in milliseconds)
  REDIRECT_DELAY: 1000,
  SCORE_REDIRECT_DELAY: 2000,
  MAP_REVEAL_DELAY: 1000,

  // Timer durations (in seconds)
  DEFAULT_GAME_TIMER: 120,
  DEFAULT_SURVIVAL_TIMER: 60,

  // Session expiry
  SESSION_EXPIRY_HOURS: 24
} as const;

/**
 * Storage key constants
 */
export const STORAGE_KEYS = {
  // Arcade mode
  ARCADE_GAME_SESSION: 'arcadeGameSession',
  ARCADE_CONFIG: 'arcadeConfig',

  // Spotlight mode
  SPOTLIGHT_GAME_SESSION: 'spotlightGameSession',

  // Game state (using sessionStorage for temporary game state)
  GAME_STATE: 'game-state',

  // Survival mode
  SURVIVAL_START_TIME: (sessionId: string) =>
    `survival_start_time_${sessionId}`,
  SURVIVAL_GAMES_PLAYED: (sessionId: string) =>
    `survival_games_played_${sessionId}`,
  SURVIVAL_RIDDLES_SEEN: (sessionId: string) =>
    `survival_riddles_seen_${sessionId}`,
  SURVIVAL_PARTIAL_MATCHING_THRESHOLD: (sessionId: string) =>
    `survival_partial_matching_threshold_${sessionId}`,

  // User
  ANONYMOUS_ID: 'anonymous_id'
} as const;
